import { useCallback } from 'react';

const useAbsolutePosition = () => {
  // Get absolute position of a node based on allNodes array
  const handleAbsolutePosition = useCallback((node, allNodes) => {
    let x = node?.position?.x ?? 0;
    let y = node?.position?.y ?? 0;
    let parentId = node?.parentId;

    while (parentId) {
      // eslint-disable-next-line
      const parent = allNodes?.find((n) => n?.id === parentId);
      if (!parent) break;
      x += parent?.position?.x ?? 0;
      y += parent?.position?.y ?? 0;
      parentId = parent?.parentId;
    }

    return { x, y };
  }, []);

  // Get absolute position of a node based on nodeMap (Map<string, Node>)
  const handleNodeDragAbsolutePosition = useCallback((nodeId, nodeMap) => {
    let current = nodeMap.get(nodeId);
    if (!current) return { x: 0, y: 0 };

    let x = current.position.x ?? 0;
    let y = current.position.y ?? 0;

    while (current.parentId) {
      // eslint-disable-next-line
      const parent = nodeMap.get(current.parentId);
      if (!parent) break;
      x += parent.position.x ?? 0;
      y += parent.position.y ?? 0;
      current = parent;
    }

    return { x, y };
  }, []);

  // Check if a node is descendant of a group
  const handleDescendant = useCallback((childId, targetGroupId, nodeMap) => {
    let current = nodeMap.get(childId);
    while (current?.parentId) {
      if (current.parentId === targetGroupId) return true;
      current = nodeMap.get(current.parentId);
    }
    return false;
  }, []);

  return {
    handleAbsolutePosition,
    handleNodeDragAbsolutePosition,
    handleDescendant
  };
};

export default useAbsolutePosition;
